import { StoredServiceAction } from "src/app/driver/storage/models/stored-service-action";

/**
 * An instance of the StoredServiceAction model to be used for schema validation
 */
export const storedServiceActionInstance: StoredServiceAction = {
	ActionType: 0,
	Required: false,
	CompletedDate: new Date()
}